// Package Imports
import { toJS } from "mobx"

// Project Imports
import OptimizationStore from "../../store/OptimizationStore";
import changeLaApiCall from "./changeLaApiCall";
import * as APITypes from "constants/API";

const updateChangeLAFamilyProductId = async (familyProductIdData, requestData, needType) => {
    let productListData = toJS(OptimizationStore.product_list_data);
    productListData.map((item) => {
      item.data.forEach((value) => {
        if (value.life_assured_details.id === requestData.family_member_id &&
          value.family_product_id === requestData.family_product_id) {
          // value.family_product_id === familyProductIdData?.old_family_product_details_id) {
          value.family_product_id = familyProductIdData.family_product_details_id;
        }
      });
      return item;
    });
    OptimizationStore.product_list_data = [...productListData];
    changeLaApiCall(familyProductIdData, needType, APITypes.CHANGE_NEW_LA)
}

export default updateChangeLAFamilyProductId